import { gql } from '@apollo/client'

export const ONBOARDING_STATUS_QUERY = gql`
  query onboardingStatus {
    onboardingStatus {
      name
      enabled
      completed
    }
  }
`

interface OnboardingStatus {
  name: string
  enabled: boolean
  completed: boolean
}

export interface OnboardingStatusData {
  onboardingStatus: OnboardingStatus[]
}
